import { h, Component } from 'preact';
import { getBlob } from 'helpers/index';
import slugify from 'utils/slugify';
import { joinClasses, loadImage } from 'utils/utils';
import s from 'components/bolt/airport/popUpWindows/easterEgg/easterEgg.sss';
import Store from 'store/store';

export default class EasterEgg extends Component {
	constructor(props) {
		super(props);
		this.state = {
			downloadData: {},
			showDownloading: false
		};
		this.videoIsPlaying = false;
		this.videoClosed = true;

		this.$video;
		this.sectionId = this.props.section.id;

		this.closeVideo = this.closeVideo.bind(this);
		this.playVideo = this.playVideo.bind(this);
		this.onPause = this.onPause.bind(this);
		this.onPlay = this.onPlay.bind(this);
		this.stopVideo = this.stopVideo.bind(this);
		this.onEasterEggLoaded = this.onEasterEggLoaded.bind(this);
	}

	componentDidMount() {
		Store.on('CLOSE_CENTRAL_EASTER_EGG', (e) => this.closeVideo(e));
	}

	onEasterEggLoaded() {
		Store.emit('EASTER_EGG_LOADED', this.sectionId);
	}

	async download(assetSrc) {
		const { downloadData } = this.state;
		const { section, client, fromSlotMachine } = this.props;
		const filename = slugify(section.name);

		Store.emit('CUSTOM_EVENT', {
			category: `${fromSlotMachine ? 'slot-machine' : 'glyph-reveal'}`,
			action: 'painting-download-click',
			label: `${section.name}_painting`
		});

		let shareData;
		let dataUrl;

		if (downloadData?.[filename]) {
			shareData = downloadData[filename].shareData;
			dataUrl = downloadData[filename].dataUrl;
		} else {
			this.setState({
				showDownloading: true
			});
			const easterEggImg = await loadImage(`${assetSrc}?_cors=1`);
			const c = document.createElement('canvas');
			const context = c.getContext('2d');
			c.width = easterEggImg.naturalWidth;
			c.height = easterEggImg.naturalHeight;
			context.drawImage(easterEggImg, 0, 0);

			const imgBlob = await getBlob(c);
			const files = [
				new File([imgBlob], filename, { type: 'image/jpeg' })
			];
			shareData = {
				files
			};
			dataUrl = c.toDataURL('image/jpeg');
			this.setState({
				downloadData: {
					...downloadData,
					[filename]: { shareData, dataUrl }
				},
				showDownloading: false
			});
		}
		
		const canShare = navigator.canShare && navigator.canShare(shareData);
		
		if (!canShare || client?.device === 'desktop') {
			const link = document.createElement('a');
			link.download = filename;
			link.href = dataUrl;
			link.style.display = 'none';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			return;
		}
		navigator.share(shareData);
	}
	
	playVideo() {
		if (!this.videoIsPlaying) {
			this.$video.play(); 
		}
	}

	onPlay() {
		this.videoIsPlaying = true;
		Store.emit('PAUSE_MUSIC');
		this.props.makeActiveWindow(this.sectionId);
	}

	onPause() {
		this.videoIsPlaying = false;
		Store.emit('RESUME_MUSIC');
	}


	closeVideo(e) {
		e.stopPropagation();
		if (!this.videoClosed) {
			this.props.onVideoEnded(e, this.sectionId);
			this.videoClosed = true;
			this.stopVideo();
		}
	}

	stopVideo() {
		if (this.videoIsPlaying) {
			this.$video.pause();
		}
	}

	render({ section, imageRoot, videoRoot, isActive, asset, assetVidFallback, fromSlotMachine, videoPoster, accessibilityTab }) {
		const { showDownloading } = this.state;

		const assetType = section.easterEgg.includes('.webp') ? 'image' : 'video' ;

		const assetSrc = asset || `${assetType == 'video' ? videoRoot : imageRoot }/airport/${section.easterEgg}`;

		if (this.$video && assetType == 'video') {
			if (isActive ) {
				if (this.videoClosed) {
					this.$video.currentTime = 0;
					this.playVideo();
					this.videoClosed = false;
				}
			} else {
				this.stopVideo();
			}
		}

		return (
			<div
				class={joinClasses(s.container, fromSlotMachine && s.fromSlotMachine)}
				onMouseDown={(e) => e.stopPropagation()}
				onTouchStart={(e) => e.stopPropagation()}
			>

				{ assetType == 'video' && (
					<video 
						class={joinClasses(s.videoAsset, isActive && s.active)}
						ref={ref => this.$video = ref} 
						muted={false} 
						playsinline 
						controls
						onEnded={(e) => this.closeVideo(e, section.id)}
						onPause={this.onPause}
						onPlay={this.onPlay}
						poster={videoPoster || `${imageRoot}/airport/${section.easterEgg}.webp`}
						onCanPlay={this.onEasterEggLoaded}
					>
						<source src={asset || `${videoRoot}/airport/${section.easterEgg}.webm`} type={'video/webm'} />
						<source src={assetVidFallback || asset || `${videoRoot}/airport/${section.easterEgg}.mp4`} type={'video/mp4'} />
					</video>
				)} 
				{ assetType == 'image' && (
					<img
						class={s.imageAsset}
						src={assetSrc}
						onLoad={this.onEasterEggLoaded}
					/>
				)}
				{assetType == 'image' && (
					<button
						class={joinClasses(s.downloadBtn, showDownloading && s.loading)}
						onClick={() => this.download(assetSrc)}
					>
						<img src={`${imageRoot}/airport/download.webp`} />
					</button>
				)}
			</div>
		);
	}
	
}